import React from 'react'
import TextField from 'material-ui-legacy/TextField'

/*
Props:
- name: field name
- required: boolean (false)
- pattern: regex to be matched for validation
- errorMessage: Self-explanatory. Default: "Invalid input"
- validatedOnChange: callback function for onChange, but including a
  validation flag and field name:
  callback(value, Bool(isValid), this.props.name)
- alignRight: boolean (false) - Align placeholder and label to the right
- errorText: Overrides internal validation and displays error message
  when present
- immediateValidation: Validates when onChange is triggered. default: false
                       When true: only validates onBlur or enter pressed

Other props will be forwarded to the TextField element.
*/

const alignRightLabel = {
  textAlign: 'right',
  right: '0px'
}

const alignRightFloatingLabel = {
  textAlign: 'right',
  right: '-6%'
}

const alignRightInputStyle = {
  textAlign: 'right'
}

class ValidatedTextInput extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      value: this.props.value || '',
      valid: true,
      errorMessage: this.props.errorMessage || 'Invalid input',
      changed: false
    }
  }

  _validate = ev => {
    const { required, pattern, name } = this.props
    const value = String(this.state.value).trim()
    let valid = true

    // Validate in two steps
    if (required) valid = value.length > 0
    if (pattern) valid = value.match(pattern)

    // Allow empty fields if not required
    if (!required && value.length === 0) valid = true

    this.setState(
      {
        valid: Boolean(valid),
        changed: true
      },
      () => {
        this.props.validatedOnChange(value, valid, name)
      }
    )
  }

  _change = ev => {
    const { immediateValidation } = this.props
    this.setState(
      { value: ev.target.value, changed: true, valid: true },
      () => {
        if (immediateValidation) this._validate()
      }
    )
  }

  _detectEnter = ev => {
    const { onKeyPress } = this.props
    if (ev.key === 'Enter') this._validate()

    // Relay event - important for forms that submit on enter
    if (onKeyPress) onKeyPress(ev)
  }

  render() {
    // Error message: errorText on props overrides all
    const errorText = this.props.errorText
      ? this.props.errorText
      : this.state.valid ? undefined : this.state.errorMessage
    let { ...newProps } = this.props
    // We're dealing with required fields ourselves
    delete newProps.required
    // Avoiding "unknown property" errors
    delete newProps.errorMessage
    delete newProps.validatedOnChange
    // Adding our processed stuff
    newProps.errorText = errorText
    newProps.onChange = this._change
    newProps.onBlur = this._validate
    newProps.onKeyPress = this._detectEnter
    newProps.value = this.state.value
    if (this.props.alignRight) {
      newProps.floatingLabelStyle = alignRightLabel
      newProps.floatingLabelShrinkStyle = alignRightFloatingLabel
      newProps.inputStyle = alignRightInputStyle
    }
    delete newProps.alignRight
    return <TextField {...newProps} />
  }
}

export default ValidatedTextInput



// WEBPACK FOOTER //
// ./src/components/UI/ValidatedTextInput.jsx